import { render, staticRenderFns } from "./cooperationGoodsList.vue?vue&type=template&id=af82533e&scoped=true"
import script from "./cooperationGoodsList.vue?vue&type=script&lang=js"
export * from "./cooperationGoodsList.vue?vue&type=script&lang=js"
import style0 from "./cooperationGoodsList.vue?vue&type=style&index=0&id=af82533e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af82533e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af82533e')) {
      api.createRecord('af82533e', component.options)
    } else {
      api.reload('af82533e', component.options)
    }
    module.hot.accept("./cooperationGoodsList.vue?vue&type=template&id=af82533e&scoped=true", function () {
      api.rerender('af82533e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/cooperation/cooperationGoodsList.vue"
export default component.exports